import { r, s } from '@/theme/tokens';
import type { SpacingToken } from '@/theme/tokens';

export const TABLE_CELL_TOP_PADDING = {
  none: '0px',
  compact: s('sm'),
  standard: s('md'),
} as const;

export const tableCellContentBoxSx = {
  width: '100%',
  maxWidth: '100%',
  minWidth: 0,
  boxSizing: 'border-box',
  alignSelf: 'flex-start',
  justifySelf: 'flex-start',
} as const;

export const tableCellContentFlexSx = {
  ...tableCellContentBoxSx,
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
} as const;

export const tableCellTextBlockSx = {
  width: '100%',
  minWidth: 0,
  display: 'flex',
  flexDirection: 'column',
  rowGap: s('none'),
} as const;

export const tableCellPrimaryTextSx = {
  width: '100%',
  minWidth: 0,
  fontSize: '15px',
  lineHeight: 1.4,
} as const;

export const tableCellSecondaryTextSx = {
  display: 'block',
  width: '100%',
  minWidth: 0,
  fontSize: '15px',
  lineHeight: 1.4,
} as const;

export const tableCellTagRowSx = {
  width: '100%',
  minWidth: 0,
  mt: s('none'),
} as const;

export const tableCellTagGap: SpacingToken = 'md';

export const tableCellTagGroupSx = {
  columnGap: s(tableCellTagGap),
  display: 'flex',
  flexWrap: 'wrap',
  maxHeight: `calc(24px * 2 + ${s(tableCellTagGap)})`,
  minWidth: 0,
  overflow: 'hidden',
  rowGap: s(tableCellTagGap),
  width: '100%',
} as const;

export const tableCellDenseTagGroupSx = {
  ...tableCellTagGroupSx,
  display: 'grid',
} as const;

export const buildTableCellDenseTagColumns = (tagCount: number): string =>
  `repeat(${String(Math.ceil(tagCount / 2))}, minmax(0, 1fr))`;

export const tableCellTagChipSx = {
  borderRadius: r('sm'),
  height: '24px',
  maxWidth: '100%',
  minWidth: 0,
  '& .MuiChip-label': {
    minWidth: 0,
    overflow: 'hidden',
    py: s('xxs'),
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  '& .MuiChip-label .MuiTypography-root': {
    fontSize: '15px !important',
    lineHeight: 1.4,
  },
} as const;

export const tableCellDenseTagChipSx = {
  width: '100%',
} as const;
